import "./HeroimgStyles.css";
import IntroImg from "../assets/psee.jpg";
import { React } from "react";
import { Link } from "react-router-dom";
// import IntroPic from "./mnpic_2.png";

const HeroImg = () => {
  return (
    <div className="hero">
      <div className="mask">
        <img className="into-img" src={IntroImg} alt="IntroImg" />
      </div>
      <div className="content">
        {/* <img className="into-pic" src={IntroPic} alt="IntroImg" /> */}
        <div>
          <p>
            {/* <b>Hi</b>, I AM NGANGMI MILLENIAN.
            <br />A dedicated React Developer | Software Engineer, and ardent
            Tech Enthusiast.
            <br /> */}
            We <b>facilitate Businesses growth</b> through the
            delivery of
            <b> qualified Leads</b>, eliminating the need for extensive effort
            on your part.
          </p>
          <div>
            <h1>
              Welcome To VIRXEE <br />
              <p style={{ fontSize: "23.5px", padding: "0px" }}>
                Your Satisfaction, 100% Guaranteed!
              </p>
            </h1>
          </div>
        </div>

        <div>
          <Link to={"/project"} className="btn">
            Project
          </Link>
          <Link to={"/contact"} className="btn btn-light">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HeroImg;
